import CharlieScreens from '../constants/screentypes/charlie';
import SoftenerScreens from '../constants/screentypes/softener';
import SuperiorScreens from '../constants/screentypes/superior';
import SimplexScreens from '../constants/screentypes/simplex';
import roles from '../constants/roles';

function getCharlieCommandByScreen(screen, number, getSCR) {
  switch (screen) {
    case CharlieScreens.IWHSCREEN:
      return 'setIWH';
    case CharlieScreens.OWHSCREEN:
      return 'setOWH';
    case CharlieScreens.WATERPRESSURESCREEN:
      return 'setMPR';
    case CharlieScreens.LANGUAGESCREEN:
      return 'setLAN';
    case CharlieScreens.SOUNDSCREENCHARLIE:
      return 'setSND';
    case CharlieScreens.UWHSCREEN:
      return 'setWHU';
    case CharlieScreens.MAINSCREENSALT1:
      return 'setSV1';
    case CharlieScreens.REGENERANTSCREEN:
      return 'setRDO';
    case CharlieScreens.RPENUMBERSCREEN:
      if (+getSCR === 1) {
        switch (number) {
          case '1':
            return 'setRPD_months';
          case '2':
            return 'setRPD_days';
          default:
            return screen;
        }
      }
      return 'setRPD';
    case CharlieScreens.RPEDAYSSCREEN:
      return 'setRPW';
    case CharlieScreens.REGENERATIONSCREEN:
      return 'setRTY';
    case CharlieScreens.CHLORINEGENERATORSCREEN:
      return 'setCHG';
    case CharlieScreens.AWUSCREEN:
      return 'setDWF';
    case CharlieScreens.RESERVETYPESCREEN:
      return 'setREK';
    case CharlieScreens.CHLORINEGENERATORTHRESHOLDRSCREEN:
      return 'setCGT';
    case CharlieScreens.RTESCREEN:
      switch (number) {
        case '1':
          return 'setRTH';
        case '2':
          return 'setRTM';
        default:
          return screen;
      }
    case CharlieScreens.RESERVEPERCENTAGESCREEN:
      return 'setCOR';
    case CharlieScreens.LEAKAGEMAXVOLUMESCREEN:
      return 'setLMV';
    case CharlieScreens.LEAKAGEMAXZEITSCREEN:
      return 'setLMT';
    case CharlieScreens.LEAKAGEPROTECTIONENABLESCREEN:
      return 'setLPE';
    case CharlieScreens.RPENUMBERDISINFECTIONSCREEN:
      return 'setMPD';
    case CharlieScreens.POEBACKWASHNODISINFECTIONSCREEN:
      switch (number) {
        case '1':
          return 'setBTM';
        case '2':
          return 'setBTS';
        default:
          return screen;
      }
    case CharlieScreens.POEFASTRINSENODISINFECTIONSCREEN:
      switch (number) {
        case '1':
          return 'setFWM';
        case '2':
          return 'setFWS';
        default:
          return screen;
      }
    case CharlieScreens.POEBACKWASHSCREEN:
      switch (number) {
        case '1':
          return 'setBDM';
        case '2':
          return 'setBDS';
        default:
          return screen;
      }
    case CharlieScreens.POEBRINEDRAWSCREEN:
      switch (number) {
        case '1':
          return 'setWDM';
        case '2':
          return 'setWDS';
        default:
          return screen;
      }
    case CharlieScreens.POESLOWRINSESCREEN:
      switch (number) {
        case '1':
          return 'setSTM';
        case '2':
          return 'setSTS';
        default:
          return screen;
      }
    case CharlieScreens.POEFASTRINSESCREEN:
      switch (number) {
        case '1':
          return 'setFDM';
        case '2':
          return 'setFDS';
        default:
          return screen;
      }
    case CharlieScreens.POEREFILLSCREEN:
      switch (number) {
        case '1':
          return 'setRDM';
        case '2':
          return 'setRDS';
        default:
          return screen;
      }
    case CharlieScreens.POEPAUSESCREEN:
      switch (number) {
        case '1':
          return 'setPDM';
        case '2':
          return 'setPDS';
        default:
          return screen;
      } 
    default:
      return screen;
  }
}


function getSimplexCommandByScreen(screen, number, getSCR) {
  switch (screen) {
    case SimplexScreens.IWHSCREEN:
      return 'setIWH';
    case SimplexScreens.OWHSCREEN:
      return 'setOWH';
    case SimplexScreens.WATERPRESSURESCREEN:
      return 'setMPR';
    case SimplexScreens.LANGUAGESCREEN:
      return 'setLAN';
    case SimplexScreens.SOUNDSCREEN:
      return 'setSND';
    case SimplexScreens.UWHSCREEN:
      return 'setWHU';
    case SimplexScreens.MAINSCREENSALT1:
      return 'setSV1';
    case SimplexScreens.MAINSCREENKMN04:
      return 'setSV1';
    case SimplexScreens.REGENERANTSCREEN:
      return 'setRDO';
    case SimplexScreens.RPENUMBERSCREEN:
      if (+getSCR === 1) {
        switch (number) {
          case '1':
            return 'setRPD_months';
          case '2':
            return 'setRPD_days';
          default:
            return screen;
        }
      }
      return 'setRPD';
    case SimplexScreens.RPEDAYSSCREEN:
      return 'setRPW';
    case SimplexScreens.REGENERATIONSCREEN:
      return 'setRTY';
    case SimplexScreens.CHLORINEGENERATORSCREEN:
      return 'setCHG';
    case SimplexScreens.PRESSURESENSORSCREEN:
      return 'setPST';
    case SimplexScreens.AWUSCREEN:
      return 'setDWF';
    case SimplexScreens.RESERVETYPESCREEN:
      return 'setREK';
    case SimplexScreens.RTESCREEN:
      switch (number) {
        case '1':
          return 'setRTH';
        case '2':
          return 'setRTM';
        default:
          return screen;
      }
    case SimplexScreens.RESERVEPERCENTAGESCREEN:
      return 'setCOR';

    case SimplexScreens.BACKWASHSCREEN:
      switch (number) {
        case '1':
          return 'setBDM';
        case '2':
          return 'setBDS';
        default:
          return screen;
      }
    case SimplexScreens.BRINEDRAWSCREEN:
      switch (number) {
        case '1':
          return 'setWDM';
        case '2':
          return 'setWDS';
        default:
          return screen;
      }
    case SimplexScreens.SLOWRINSESCREEN:
      switch (number) {
        case '1':
          return 'setSTM';
        case '2':
          return 'setSTS';
        default:
          return screen;
      }
    case SimplexScreens.FASTRINSESCREEN:
      switch (number) {
        case '1':
          return 'setFDM';
        case '2':
          return 'setFDS';
        default:
          return screen;
      }
    case SimplexScreens.REFILLSCREEN:
      switch (number) {
        case '1':
          return 'setRDM';
        case '2':
          return 'setRDS';
        default:
          return screen;
      }
    case SimplexScreens.INSPECTIONINTERVALSCREEN:
      return 'setIPE';
    case SimplexScreens.INSPECTIONUSERSCREEN:
      return 'setIPR';
    case SimplexScreens.RESERVEPERIODSCREEN:
      return 'setRPE';
    case SimplexScreens.RESINVOLUMESCREEN:
      return 'setREV';
    default:
      return screen;
  }
}

function getSoftenerCommandByScreenForCycleTimes(screen, number){
  let command = "";
  switch (screen) {
    case SoftenerScreens.REFILLINGTIMESCREEN:
      command = 'setRFT';
      break;
    case SoftenerScreens.RINSINGTIMESCREEN: 
      command = 'setBT1';
      break;
    case SoftenerScreens.RAPIDRINSINGTIMESCREEN: 
      command = 'setFT1';
      break;
    case SoftenerScreens.BRINGINGTIMESCREEN: 
      command = 'setBRT';
      break;
    case SoftenerScreens.SLOWRINSINGTIMESCREEN: 
      command = 'setSRT';
      break;
    case SoftenerScreens.BACKWASH2TIMESCREEN: 
      command = 'setBT2';
      break;
    case SoftenerScreens.RAPIDRINSING2TIMESCREEN:
      command = 'setFT2';
      break;
    case SoftenerScreens.PERIODICFLUSHINGSCREEN:
      command = 'setFLP';
      break;
  }
  switch (number) {
    case '1':
      return `${command}_minutes`;
    case '2':
      return `${command}_seconds`;
    default:
      return screen;
  }
}

function getSoftenerCommandByScreen(screen, number) {
  switch (screen) {
    case SoftenerScreens.MAINSCREENSALT1:
      return 'setSV1';
    case SoftenerScreens.MAINSCREENSALT2:
      return 'setSV2';
    case SoftenerScreens.MAINSCREENSALT3:
      return 'setSV3';
    case SoftenerScreens.IWHSCREEN:
      return 'setIWH';
    case SoftenerScreens.OWHSCREEN:
      return 'setOWH';
    case SoftenerScreens.UWHSCREEN:
      return 'setWHU';
    case SoftenerScreens.RTESCREEN:
      switch (number) {
        case '1':
          return 'setRTH';
        case '2':
          return 'setRTM';
        default:
          return screen;
      }
    case SoftenerScreens.RPESCREENMAIN:
      switch (number) {
        case '1':
          return 'setRPW';
        case '2':
          return 'setRPD';
        default:
          return screen;
      }
    case SoftenerScreens.AWUSCREEN:
      return 'setDWF';
    case SoftenerScreens.FCOSCREEN:
      return 'setFCO';
    case SoftenerScreens.RESERVETYPESCREEN:
      return 'setREK';
    case SoftenerScreens.RESERVEPERCENTAGESCREEN:
      return 'setCOR';
    case SoftenerScreens.RESERVEPERIODSCREEN:
      return 'setRPE';
    case SoftenerScreens.REFILLINGTIMESCREEN:
    case SoftenerScreens.RINSINGTIMESCREEN: 
    case SoftenerScreens.RAPIDRINSINGTIMESCREEN: 
    case SoftenerScreens.BRINGINGTIMESCREEN: 
    case SoftenerScreens.SLOWRINSINGTIMESCREEN: 
    case SoftenerScreens.BACKWASH2TIMESCREEN: 
    case SoftenerScreens.RAPIDRINSING2TIMESCREEN:
      return getSoftenerCommandByScreenForCycleTimes(screen, number);
    case SoftenerScreens.RPENUMBERSCREEN:
      return 'setRPD';
    case SoftenerScreens.RESINVOLUMESCREEN:
      return 'setREV';
    case SoftenerScreens.REGENERANTSCREEN:
      return 'setRDO';
    case SoftenerScreens.REGENERATIONSCREEN:
      return 'setRTY';
    case SoftenerScreens.PRESSURESENSORSCREEN:
      return 'setPST';
    case SoftenerScreens.WATERPRESSURESCREEN:
      return 'setMPR';
    case SoftenerScreens.CHLORINEGENERATORSCREEN:
      return 'setCHG';
    case SoftenerScreens.CANCELVACATIONMODESCREEN:
      return 'setHOT';
    case SoftenerScreens.IMMEDIATEREGENERATIONSCREEN:
    case SoftenerScreens.IMMEDIATEREGENERATIONNEWSCREEN:
      return 'setSIR';
    case SoftenerScreens.DELAYEDREGENERATIONSCREEN:
    case SoftenerScreens.DELAYEDREGENERATIONNEWSCREEN:
      return 'setSDR';
    case SoftenerScreens.IMMEDIATEMULTIREGENERATIONSCREEN:
    case SoftenerScreens.IMMEDIATEMULTIREGENERATIONNEWSCREEN:
      return 'getSMR';
    case SoftenerScreens.RPEDAYSSCREEN:
      return 'setRPW';
    case SoftenerScreens.LANGUAGESCREEN:
      return 'setLAN';
    case SoftenerScreens.PERIODICFLUSHINGSCREEN:
      switch (number) {
        case '1':
          return 'setFLP';
        case '2':
          return 'setFLL';
        default:
          return screen;
      }
    default:
      console.log('not implemented command for ', screen)
      return 'notImplemented';
  }
}

function getSuperiorCheckCommandByScreen(screen, number){
  switch (screen) {
    case SuperiorScreens.DEGASSINGFIRSTSCREEN:
      switch (number) {
        case '1':
          return 'setDE1';
        case '2':
          return 'setPE1';
        default:
          return screen;
      }
    case SuperiorScreens.DEGASSINGSECONDSCREEN:
      switch (number) {
        case '1':
          return 'setDE2';
        case '2':
          return 'setPE2';
        default:
          return screen;
      }
    case SuperiorScreens.BLOCKDEGASSINGPERIODSCREEN1:
      return 'setBE1';
    case SuperiorScreens.BLOCKDEGASSINGPERIODSCREEN2:
      return 'setBE2';
    case SuperiorScreens.BLOCKDEGASSINGPERIODSCREEN3:
      return 'setBE3';
    case SuperiorScreens.BLOCKDEGASSINGPERIODSCREEN4:
      return 'setBE4';
    case SuperiorScreens.BLOCKDEGASSINGPERIODSCREEN5:
      return 'setBE5';
    case SuperiorScreens.BOILERINTERLOCKSETTINGSSCREEN:
      return 'setBIC';
    case SuperiorScreens.EXTERNALPUMPSCREEN:
      return 'setEPV';
    default:
      break;
  };
}

function getSuperiorCommandByScreen(screen, number) {
  switch (screen) {
    case SuperiorScreens.BOILERINTERLOCKPRESSURESSCREEN:
      switch (number) {
        case '1':
          return 'setBIL';
        case '2':
          return 'setBIH';
        default:
          return screen;
      }
    case SuperiorScreens.BLOCKDEGASSINGWEEKDAYSCREEN:
      return 'setDBW';
    case SuperiorScreens.BOILSERINTERLOCKCONTACTDELAYSCREEN:
      return 'setCRD';
    case SuperiorScreens.LANGUAGESCREEN:
      return 'setLAN';
    case SuperiorScreens.COMMONFAULTSCREEN:
      return 'setCFM';
    case SuperiorScreens.FLUSHINGPHASESCREEN:
      return 'setRT9';
    case SuperiorScreens.VACCUMPHASESCREEN:
      return 'setVT9';
    case SuperiorScreens.SMARTSWITCHDELAYSCREEN:
      return 'setSSD';
    case SuperiorScreens.MAXALLOWABLEPRESSUREDIFFSCREEN:
      return 'setMPD';
    case SuperiorScreens.INITIALFILLTIMESCREEN:
      return 'setIFT';
    case SuperiorScreens.DELTAPRESSURESCREEN:
      switch (number) {
        case '1':
          return 'setLDP';
        case '2':
          return 'setUDP';
        default:
          return screen;
      }
    case SuperiorScreens.PUMPTESTTIMESCREEN:
      switch (number) {
        case '1':
          return 'setPTP';
        case '2':
          return 'setPTT';
        default:
          return screen;
      }
    case SuperiorScreens.SYSTEMFILLTIMESSCREEN:
      return 'setSFV';
    case SuperiorScreens.WATERCRITICALTEMPSCREEN:
      switch (number) {
        case '1':
          return 'setMIT';
        case '2':
          return 'getMAT';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.DEGASSINGFIRSTSCREEN:
      switch (number) {
        case '1':
          return 'setDH1';
        case '2':
          return 'setDM1';
        case '3':
          return 'setPH1';
        case '4':
          return 'setPM1';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.DEGASSINGSECONDSCREEN:
      switch (number) {
        case '1':
          return 'setDH2';
        case '2':
          return 'setDM2';
        case '3':
          return 'setPH2';
        case '4':
          return 'setPM2';
        default:
          return 'notImplemented';
      }

    case SuperiorScreens.BLOCKDEGASSINGPERIODSCREEN1:
      switch (number) {
        case '1':
          return 'setBD1';
        case '2':
          return 'setBM1';
        case '3':
          return 'setKD1';
        case '4':
          return 'setKM1';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.BLOCKDEGASSINGPERIODSCREEN2:
      switch (number) {
        case '1':
          return 'setBD2';
        case '2':
          return 'setBM2';
        case '3':
          return 'setKD2';
        case '4':
          return 'setKM2';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.BLOCKDEGASSINGPERIODSCREEN3:
      switch (number) {
        case '1':
          return 'setBD3';
        case '2':
          return 'setBM3';
        case '3':
          return 'setKD3';
        case '4':
          return 'setKM3';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.BLOCKDEGASSINGPERIODSCREEN4:
      switch (number) {
        case '1':
          return 'setBD4';
        case '2':
          return 'setBM4';
        case '3':
          return 'setKD4';
        case '4':
          return 'setKM4';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.BLOCKDEGASSINGPERIODSCREEN5:
      switch (number) {
        case '1':
          return 'setBD5';
        case '2':
          return 'setBM5';
        case '3':
          return 'setKD5';
        case '4':
          return 'setKM5';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.ALTERNATIVEDEGASSINGDURATIONSCREEN:
      return 'setADD';
    case SuperiorScreens.MINSHORTVACUUMTIMESCREEN:
      return 'setMSV';
    case SuperiorScreens.CRITICALERRCONTACTDELAYSCREEN:
      return 'setCRD';
    case SuperiorScreens.REFILLVOLUMESCREEN:
      return 'setRAV';
    case SuperiorScreens.REFILLTIMESCREEN:
      return 'setRAT';
    case SuperiorScreens.REFILLPERIODSCREEN:
      return 'setRAP';
    case SuperiorScreens.MINREFILLINTERVALSCREEN:
      return 'setMRI';
    case SuperiorScreens.FLUSHPERIODCOMPARESCREEN:
      return 'setFPC';
    case SuperiorScreens.FLUSHPERIODSTARTSCREEN:
      return 'setFPS';
    case SuperiorScreens.CRITICALREFILLTIMESCREEN:
      switch (number) {
        case '1':
          return 'setCRF';
        case '2':
          return 'setCRS';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.WARNING01TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setW01';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.WARNING02TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setW02';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.WARNING10TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setW10';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.WARNING11TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setT11';
        case '2':
          return 'setS11';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.WARNING31TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setW31';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.ERROR71TIMERSCREEN:
      switch (number) {
        case '2':
          return 'setEC6';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.ERROR72TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setET7';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.ERROR33TIMERSCREEN:
      switch (number) {
        case '2':
          return 'setC33';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.ERROR35TIMERSCREEN:
      switch (number) {
        case '2':
          return 'setC35';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.ERROR36TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setE36';
        case '2':
          return 'setC36';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.ERROR37TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setE37';
        case '2':
          return 'setC37';
        default:
          return 'notImplemented';
      }

    case SuperiorScreens.UNITTYPESCREEN:
      return 'setDTY';
    case SuperiorScreens.EXTERNALPUMPSCREEN:
      return 'setEPV';
    case SuperiorScreens.ERRORDETECTIONSCREEN:
      return 'setEDT';
    case SuperiorScreens.MEDIUMSUPERIORSCREEN:
      return 'setMED';
    case SuperiorScreens.PRESSURESENSORTYPESCREEN:
      return 'setPST';
    case SuperiorScreens.MINREFILLFLOWSCREEN:
      return 'setMRF';
    case SuperiorScreens.MINSYSTEMPRESSURE:
      return 'setMOP';
    case SuperiorScreens.PRESSUREMEASURESETTINGSSCREEN:
      switch (number) {
        case '1':
          return 'setPDL';
        case '2':
          return 'setPSN';
        default:
          return 'notImplemented';
      }
    case SuperiorScreens.INITIALDEAERATIONSCREEN:
      return 'setIDT';
    case SuperiorScreens.BOILERINTERLOCKSETTINGSSCREEN:
      return 'setBIM';
    case SuperiorScreens.REFILLPRESSURESCREEN:
    default:
      return 'notImplemented';
  }
}

export function getCommandByScreen(screen, devicetype, position, getSCR) {
  switch (devicetype) {
    case 'charlie':
      return getCharlieCommandByScreen(screen, position, getSCR);
    case 'simplex':
      return getSimplexCommandByScreen(screen, position, getSCR);
    case 'softener':
      return getSoftenerCommandByScreen(screen, position);
    case 'superior':
      return getSuperiorCommandByScreen(screen, position);
    case 'reverseosmosis':
      return '';
    default:
      return '';
  }
}

export function getCheckCommandByScreen(screen, devicetype, position) {
  switch (devicetype) {
    case 'superior':
      return getSuperiorCheckCommandByScreen(screen, position);
    default:
      return '';
  }
}

export function getDeviceType(serial) {
  let deviceType = 'unknown';
  if (typeof serial !== 'undefined') {
    if (serial.startsWith('L')) {
      deviceType = 'softener';
    }
    if (serial.startsWith('C')) {
      deviceType = 'charlie';
    }
    if (serial.startsWith('S')) {
      deviceType = 'superior';
    }
    if (serial.startsWith('F')) {
      deviceType = 'foxtrot';
    }
    if (serial.startsWith('A')) {
      deviceType = 'safe-t';
    }
    if (serial.startsWith('T')) {
      deviceType = 'safetech';
    }
    if (serial.startsWith('K')) {
      deviceType = 'safefloor';
    }
    if (serial.startsWith('M')) {
      deviceType = 'simplex';
    }
  }
  return deviceType;
}

function dec2bin(dec) {
  return (dec >>> 0).toString(2);
}

function pad(num, size) {
  const s = `00000${num}`;
  return s.substr(s.length - size);
}

export function padNew(value, size) {
  if (value === "--")
    return value;
  const sign = Math.sign(value) === -1 ? '-' : '';
  return sign + new Array(size).concat([Math.abs(value)]).join('0').slice(-size);
}

export function changeFromBits(value) {
  const decValue = pad(dec2bin(value), 2);
  const newValue = decValue
    .split("")
    .reverse()
    .join();
  return newValue;
}

export function getChlorineGeneratorThreshold(getCGT){
  if (getCGT !== undefined && getCGT != ""){
    return +getCGT == 0 ? "150mA" : "50mA"
  }
  return ""
 
}

export function getLinkToDevice(deviceType, serial) {
  switch (deviceType) {
    case 'safetech':
      return `T${serial}`;
    case 'safefloor':
      return `K${serial}`;
    case 'safe-t':
      return `A${serial}`;
    default:
      return serial;
  }
};


export function handleBlockDays(value, daysString) {
  const days = [0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40];
  const valueInt = parseInt(value, 10);
  let myString = '';
  for (let i = 0; i < 7; i += 1) {
    if (valueInt & days[i]) {
      if (i > 0) {
        if (myString === '') {
          myString += daysString[i];
        } else {
          myString += ',';
          myString += daysString[i];
        }
      } else {
        myString += daysString[i];
      }
    }
  }
  return myString;
}

export function isPriviliged(userRole) {
  const priviligedRoles = [+roles.admin, +roles.manufacturer, +roles.service];
  return priviligedRoles.indexOf(+userRole) > -1;
}

export function isAdmin(userRole) {
  const priviligedRoles = [+roles.admin];
  return priviligedRoles.indexOf(+userRole) > -1;
}

export function getPayloadId(payload, alertType) {
  switch (alertType) {
    case 'softener-device-notification':
      return `softener_notifications_${payload}_text`;
    case 'softener-device-alarm':
      return `softener_alarm_${payload}_text`;
    case 'superior-device-notification':
      return `problems_dictionary_${payload}_sup`;
    case 'superior-device-alarm':
      return `problems_dictionary_${payload}_sup`;
    case 'safetech-device-alarm':
      return `safetech_alarm_${payload.substring(1)}_text`;
    case 'safet-device-alarm':
      return `safet_alarm_${payload.substring(1)}_text`;
    default:
      return 'problems_dictionary_0_sup';
  }
}



// WEBPACK FOOTER //
// ./src/core/deviceHelper.js